import { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";
import { Eye, EyeSlash, Copy, Check, Shuffle } from "@phosphor-icons/react";
import { toast } from "sonner";

const ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789!#%&*+-?@";
export const generatePassword = (len = 14) => {
  const buf = new Uint32Array(len);
  window.crypto.getRandomValues(buf);
  let out = Array.from(buf, (n) => ALPHABET[n % ALPHABET.length]).join("");
  if (!/[0-9!#%&*+\-?@]/.test(out)) out = out.slice(0, -1) + "7";
  return out;
};

export const passwordProblem = (pw) => {
  if (pw.length < 10) return "At least 10 characters";
  if (!/[A-Za-z]/.test(pw) || !/[^A-Za-z]/.test(pw)) return "Use letters plus a number or symbol";
  return null;
};

// Password + "must change at next sign-in" fields used by Add admin and Set password flows.
export function PasswordFields({ value, onChange, forceChange, onForceChange, idPrefix = "pw" }) {
  const [show, setShow] = useState(false);
  const [copied, setCopied] = useState(false);
  const problem = value ? passwordProblem(value) : null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(value); setCopied(true); setTimeout(() => setCopied(false), 1500); } catch { toast.error("Couldn't copy"); }
  };
  return (
    <div className="space-y-3">
      <div className="space-y-1.5">
        <Label htmlFor={`${idPrefix}-input`}>Password</Label>
        <div className="flex gap-2">
          <div className="relative flex-1">
            <Input id={`${idPrefix}-input`} type={show ? "text" : "password"} value={value} onChange={(e) => onChange(e.target.value)} className="pr-9 font-mono text-sm" autoComplete="new-password" data-testid={`${idPrefix}-input`} />
            <button type="button" onClick={() => setShow((v) => !v)} className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground" aria-label={show ? "Hide password" : "Show password"} data-testid={`${idPrefix}-toggle`}>
              {show ? <EyeSlash size={16} /> : <Eye size={16} />}
            </button>
          </div>
          <Button type="button" variant="outline" size="sm" className="h-9 px-2.5" onClick={() => { onChange(generatePassword()); setShow(true); }} data-testid={`${idPrefix}-generate`}><Shuffle size={14} className="mr-1" /> Generate</Button>
          <Button type="button" variant="outline" size="sm" className="h-9 px-2.5" disabled={!value} onClick={copy} data-testid={`${idPrefix}-copy`}>{copied ? <Check size={14} /> : <Copy size={14} />}</Button>
        </div>
        <p className={`text-[11px] ${problem ? "text-amber-700 dark:text-amber-400" : "text-muted-foreground"}`} data-testid={`${idPrefix}-hint`}>
          {problem || "At least 10 characters with letters plus a number or symbol. Share it with the person directly — it's never e-mailed."}
        </p>
      </div>
      <label className="flex items-center gap-2 text-xs cursor-pointer">
        <Switch checked={forceChange} onCheckedChange={onForceChange} data-testid={`${idPrefix}-force-change`} />
        <span>Ask them to choose their own password at next sign-in</span>
      </label>
    </div>
  );
}
